// react
import React from 'react';

// material ui icons
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

// material ui
import { Avatar, CardHeader } from '@mui/material';
import { alpha } from '@mui/material/styles';

// shared components
import InfoTooltipIcon from '@/components/ui/icon/InfoTooltipIcon';

/**
 * Reusable CardHeader component with icon and tooltip.
 *
 * Props:
 * - icon: React node (e.g., <SpeedRoundedIcon />)
 * - tooltip: string (tooltip text shown on hover)
 * - iconColor: string (default: '#96b100')
 * - iconBgColor: string (default: '#c2dd00')
 * - title: string or node (optional CardHeader title)
 * - subheader: string or node (optional CardHeader subheader)
 * - actionIcon: React node (optional custom action icon instead of default InfoRoundedIcon)
 */
const CardHeaderWithIcon = ({
  icon,
  tooltip,
  iconColor = '#c2dd00',
  iconBgColor = alpha('#c2dd00', 0.1),
  title,
  subheader = null,
  actionIcon = null,
  dimmed = false,
  children = null,
  sx = {},
}) => {
  return (
    <>
      <CardHeader
        sx={{
          p: 0,
          opacity: dimmed ? 0.2 : 1,
          transition: 'opacity 0.3s ease-in-out',
          display: 'flex',
          mb: 1,
          ...sx,
        }}
        title={title}
        avatar={
          <Avatar
            variant="rounded"
            sx={{
              bgcolor: iconBgColor,
              borderRadius: 3,
            }}
          >
            {icon &&
              React.cloneElement(icon, {
                sx: { verticalAlign: 'middle', color: iconColor },
              })}
          </Avatar>
        }
        subheader={subheader}
        action={
          tooltip && (
            <InfoTooltipIcon title={tooltip} placement="top" arrow>
              {actionIcon || (
                <InfoRoundedIcon
                  sx={{
                    color: (theme) =>
                      theme.palette.mode === 'light' ? 'lightgray' : 'gray',
                    ml: 1,
                  }}
                  fontSize="small"
                />
              )}
            </InfoTooltipIcon>
          )
        }
        slotProps={{
          title: {
            variant: 'subtitle1',
            fontWeight: 600,
            // color: 'textSecondary',
          }
        }}
      />
      {children}
    </>
  );
};

export default CardHeaderWithIcon;
